<form action="#">
    <div class="search-control-list"></div>
    <div class="add-filter-container"></div>
    <div class="add-filter-btn-container">
        <button class="btn btn-tertiary" type="button" data-control="addFilter">{{locale "addAnotherFilter"}}</button>
    </div>
 </form>